import React from 'react';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { WhatsApp } from './WhatsApp';
import whatsappReducer from './slice-whatsapp';

// Create a store specifically for WhatsApp if not already integrated
const store = configureStore({
  reducer: {
    whatsapp: whatsappReducer,
  },
});

export const WhatsAppModule: React.FC = () => {
  return (
   // <Provider store={store}>
      <> <WhatsApp /> </>
  //  </Provider>
  );
};


